module.exports = __webpack_public_path__ + "static/img/Jacob-Laban.62f3e99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jacob-Laban.jpg
// module id = z5RS
// module chunks = 0